module.exports = {
      id: "marker-usage",
      viewBox: "0 0 38 54",
      url: __webpack_public_path__ + "img/icons.56e2db0a.svg#marker-usage",
      toString: function () {
        return this.url;
      }
    }